import CycleConfigAuthProvider from './auth-provider';
import CycleConfigDataProvider from './data-provider';

export const authProvider = new CycleConfigAuthProvider();
export const dataProvider = new CycleConfigDataProvider(
  process.env.REACT_APP_CYCLE_CONFIG_API_URI as string,
);
